// Web no-op: browser permissions are handled by the getUserMedia probe in
// CallWebContainer. The native implementation lives in
// useNativeMediaPermissions.native.ts.
export const useNativeMediaPermissions = (): {
  status: "pending" | "granted" | "denied";
} => ({ status: "granted" });
